import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'
import Traduction from 'Components/Traduction'
import Upload from 'Components/Upload'
import Constants from 'EurestoFonction/Constants'
import React from 'react'


export default class SaisieLibreDocument extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} title={this.props.title}>
        <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'} alignItems={'center'}>
          <Grid item xs style={{margin: 0, padding: 0}}>
            <Traduction style={this.props.style}
              onChange={this.props.onChangeSaisieLibreBool}
              name={'text'}
              disabled={this.props.disabled || false}
              data={this.props.data !== undefined && this.props.data.text !== undefined ? this.props.data.text : []}
              type={Constants.typeSaisie.SaisieLibre}
            />
          </Grid>
          {this.props.client_id && <Grid item style={{margin: 0, padding: 0}}>
            <Upload disabled={this.props.disabled || false} media_id={data.valeur_entier} link={data.media_lien} client_id={this.props.client_id} onChange={(r) => this.props.onChangeSaisieLibreUpload(r.id, r.lien)}/>
          </Grid> }
        </Grid>
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/SaisieLibre/SaisieLibreDocument.js